import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const PricingDescription = () => {
  const words = [
    "age",
    "address",
    "gender",
    "work history",
    "phone number",
    "email",
    "education history",
    "social profiles",
    "employment history",
  ];

  const [index, setIndex] = useState(0);
  const cap = (text) => text.charAt(0).toUpperCase() + text.slice(1);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000);
    return () => clearInterval(id);
  }, [words.length]);

  return (
    <Box
      component="section"
      sx={{
        color: "black",
        position: "relative",
        overflow: "hidden",
        pt: 8,
        mt: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          width: "100%",
        }}
      >
        <Typography
          variant="h4"
          component="div"
          sx={{ fontWeight: 900, lineHeight: 1.25, color: "black" }}
        >
          Subscribe Today and Safeguard Your{" "}
          <Box
            component="span"
            sx={{ position: "relative", display: "inline", color: "#12b2f1" }}
          >
            {/* Invisible text of the longest word holds the inline width */}
            <Box
              component="span"
              sx={{ visibility: "hidden", userSelect: "none" }}
            >
              Employment history
            </Box>

            {words.map((word, i) => (
              <Box
                key={word}
                component="span"
                sx={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  opacity: i === index ? 1 : 0,
                  transform: i === index ? "translateY(0)" : "translateY(8px)",
                  transition: "opacity 0.45s ease, transform 0.45s ease",
                  whiteSpace: "nowrap",
                }}
              >
                {cap(word)}
              </Box>
            ))}
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default PricingDescription;
